import { modelViewerActions } from "./reducer";

export const updateTopAction = (action) => async (dispatch) => {
  try {
    dispatch(modelViewerActions.updateTopAction(action));
  } catch (error) {
    console.log(error);
  }
};
